export interface CIInfo {
  customerType: 'existingPartner' | 'existingResidentialPartner' | 'businessOwner' | 'installer'
  partnerCompanyName?: string
  siteOwnerCompany?: string
  formSubmitterName?: string
  ptoDate?: string
  acCapacity?: number
  dcCapacity?: number
}

export interface UtilityCompany {
  utilityName: string
}

export const Utilities: UtilityCompany[] = [
  { utilityName: 'Pacific Gas & Electric (PG&E)' },
  { utilityName: 'Southern California Edison (SCE)' },
  { utilityName: 'San Diego Gas & Electric (SDG&E)' },
]

export const OtherUtilities: UtilityCompany[] = [
  { utilityName: 'Alameda Municipal Power' },
  { utilityName: 'Anaheim, City of' },
  { utilityName: 'Apple Valley Choice Energy' },
  { utilityName: 'Arizona Public Service' },
  { utilityName: 'Ava Community Energy Authority' },
  { utilityName: 'Avista' },
  { utilityName: 'Avista Utilities' },
  { utilityName: 'Azusa Light and Water' },
  { utilityName: 'Banning, City of' },
  { utilityName: 'Bear Valley' },
  { utilityName: 'Benton County Public Utility District' },
  { utilityName: 'Big Bend Electric' },
  { utilityName: 'Biggs Municipal Utilities' },
  { utilityName: 'Black Hills Power' },
  { utilityName: 'Blachly-Lane Electric Cooperative' },
  { utilityName: 'Boulder City Electric Utility' },
  { utilityName: 'Bridger Valley' },
  { utilityName: 'Burbank Water and Power' },
  { utilityName: 'Carbon Power & Light (A cooperative of Touchstone Energy)' },
  { utilityName: 'Central Coast Commnity Energy' },
  { utilityName: 'Chelan County Public Utility District' },
  { utilityName: 'Cheyenne Light, Fuel & Power' },
  { utilityName: 'City of Bountiful' },
  { utilityName: 'City of Kaysville' },
  { utilityName: 'City of Milton' },
  { utilityName: 'Clark Public Utilities' },
  { utilityName: 'Clean Energy Alliance' },
  { utilityName: 'Clean Power Alliance of Southern California' },
  { utilityName: 'CleanPowerSF' },
  { utilityName: 'Clearwater Power' },
  { utilityName: 'Colorado Springs Utilities' },
  { utilityName: 'Colton Public Utilities' },
  { utilityName: 'Columbia River PUD' },
  { utilityName: 'Columbia Rural Electric' },
  { utilityName: 'Consumers Power Inc.' },
  { utilityName: 'Coos-Curry Electric Coop' },
  { utilityName: 'Corona, City of' },
  { utilityName: 'Department of Water Resources' },
  { utilityName: 'Desert Community Energy' },
  { utilityName: 'Douglas County Public Utility District' },
  { utilityName: 'Douglas Electric Cooperative' },
  { utilityName: 'El Paso Electric' },
  { utilityName: 'Elmurst Mutual' },
  { utilityName: "Energy for Palmdale's Independent Choice (CPALM)" },
  { utilityName: 'Eugene Water & Electric Board (EWEB)' },
  { utilityName: 'Franklin County Public Utility District' },
  { utilityName: 'Glendale Water and Power' },
  { utilityName: 'Grant County Public Utility District' },
  { utilityName: 'Gridley Electric Utility' },
  { utilityName: 'Harney Electric Cooperative' },
  { utilityName: 'Healdsburg, City of, Electric Department' },
  { utilityName: 'Hood River Electric & Internet Co-op' },
  { utilityName: 'IDACORP (Idaho Power)' },
  { utilityName: 'Imperial Irrigation District' },
  { utilityName: 'Industry, City of' },
  { utilityName: 'Intermountain Rural Electrical Association' },
  { utilityName: 'IPA' },
  { utilityName: 'King City Community Power' },
  { utilityName: 'Kirkwood Meadows Public Utility District' },
  { utilityName: 'Klickitat Public Utility District' },
  { utilityName: 'La Plata Electric Association' },
  { utilityName: 'Lakeview Light & Power' },
  { utilityName: 'Lancaster Choice Energy' },
  { utilityName: 'Lassen Municipal Utility District' },
  { utilityName: 'Lathrop Irrigation District' },
  { utilityName: 'Liberty Utilities' },
  { utilityName: 'Lincoln County Power' },
  { utilityName: 'Lodi Electric Utility' },
  { utilityName: 'Lompoc, City of, Electric Division' },
  { utilityName: 'Los Angeles Department of Water and Power' },
  { utilityName: 'Lower Valley Energy' },
  { utilityName: 'Marin Clean Energy' },
  { utilityName: 'Mason County Public Utility District 3' },
  { utilityName: 'Merced Irrigation District' },
  { utilityName: 'Metropolitan Water District of Southern California' },
  { utilityName: 'Midstate Electric Cooperative' },
  { utilityName: 'Modern Electric Water' },
  { utilityName: 'Modesto Irrigation District' },
  { utilityName: 'Moreno Valley Electric Utility' },
  { utilityName: 'Mt Wheeler Power' },
  { utilityName: 'Needles, City of' },
  { utilityName: 'Nespelem Valley Electric' },
  { utilityName: 'NextEra (Valley Electric Association)' },
  { utilityName: 'Niobrara Electric' },
  { utilityName: 'NV Energy (Nevada Power)' },
  { utilityName: 'Ohop Mutual' },
  { utilityName: 'Okanaogan Country Electric & Propane' },
  { utilityName: 'Orange County Power Authority' },
  { utilityName: 'Orcas Power and Light Coop (OPALCO)' },
  { utilityName: 'Overton Power' },
  { utilityName: 'PacifiCorp (Pacific Power)' },
  { utilityName: 'PacifiCorp (Rocky Mountain Power)' },
  { utilityName: 'Pacificorp' },
  { utilityName: 'pacificorp (Dominion Energy)' },
  { utilityName: 'Page Power and Water' },
  { utilityName: 'Palo Alto, City of, Utilities Department' },
  { utilityName: 'Parkland Light & Water' },
  { utilityName: 'Pasadena Water and Power' },
  { utilityName: 'Peninsula Clean Energy' },
  { utilityName: 'Pico Rivera Innovative Municipal Energy' },
  { utilityName: 'Pioneer Community Energy' },
  { utilityName: 'Pittsburg, City of (dba Island Energy on Mare Island)' },
  { utilityName: 'Platte River Power Authority' },
  { utilityName: 'Plumas Sierra Electric Cooperative' },
  { utilityName: 'Pomona Choice Energy (ex CPOM)' },
  { utilityName: 'Port of Oakland' },
  { utilityName: 'Port of Stockton' },
  { utilityName: 'Portland General Electric' },
  { utilityName: 'Poudre Valley Rural Electric Association' },
  {
    utilityName:
      'Power Enterprise of the San Francisco Public Utilities Commission',
  },
  {
    utilityName:
      'Powder River Energy Corporation (A cooperative of Touchstone Energy)',
  },
  { utilityName: 'Public Service Company of New Mexico' },
  { utilityName: 'Rancho Cucamonga Municipal Utility' },
  { utilityName: 'Rancho Mirage Energy Authority' },
  { utilityName: 'Redding Electric Utility' },
  { utilityName: 'Redwood Coast Energy Authority' },
  { utilityName: 'Riverside, City of' },
  { utilityName: 'Roseville Electric' },
  { utilityName: 'Sacramento Municipal Utility District' },
  { utilityName: 'Salem Electric' },
  { utilityName: 'Salt River Project' },
  { utilityName: 'San Diego Community Power' },
  { utilityName: 'San Jacinto Power' },
  { utilityName: 'San Jose Clean Energy' },
  { utilityName: 'Santa Barbara Clean Energy' },
  { utilityName: 'Shasta Lake, City of' },
  { utilityName: 'Silicon Valley Clean Energy' },
  { utilityName: 'Silicon Valley Power' },
  { utilityName: 'Sonoma Clean Power Authority' },
  {
    utilityName:
      'Southwestern Public Service Company, a subsidiary of Xcel Energy',
  },
  { utilityName: 'Springfield Utility Board' },
  { utilityName: 'Surprise Valley Electric Cooperative' },
  { utilityName: 'Texas-New Mexico Power' },
  { utilityName: 'Total CCA Retail Sales' },
  { utilityName: 'Tri-State Generation and Transmission Association' },
  {
    utilityName:
      'Tri-State Generation and Transmission Association (A cooperative of Touchstone Energy)',
  },
  { utilityName: 'Truckee Donner Public Utility District' },
  { utilityName: 'Tucson Electric Power' },
  { utilityName: 'Turlock Irrigation District' },
  { utilityName: 'Ukiah, City of' },
  { utilityName: 'Umatilla Electric Cooperative' },
  { utilityName: 'UniSource Energy Services' },
  { utilityName: 'Valley Clean Energy Alliance' },
  { utilityName: 'Vernon, City of' },
  { utilityName: 'Victorville Municipal Utility Services' },
  { utilityName: 'Wells Rural Electric Company' },
  { utilityName: 'West Oregon Electric Cooperative' },
  { utilityName: 'Western Area Power Administration' },
]

export class SrecRegistration {
  constructor(
    firstName: string,
    lastName: string,
    address: Address,
    emailAddress: string,
    referralSource: string,
    phone: string,
    phoneType: string,
    loanType: string,
    utility: Utility,
    serviceAddress: Address,
    meter: Meter,
    additionalComment: string,
    clientIPAddress: string,
    formSubmissionTimestamp: string,
    supportingFiles: SupportingFile[],
    files: File[],
    referenceNumber: string,
    ciInfo?: CIInfo
  ) {
    this.FirstName = firstName
    this.LastName = lastName
    this.Address = address
    this.EmailAddress = emailAddress
    this.ReferralSource = referralSource
    this.PhoneNumber = phone
    this.PhoneNumberType = phoneType
    this.IsSystemOwner = true
    this.LoanType = loanType
    this.Utility = utility
    this.ServiceAddress = serviceAddress
    this.Meter = meter
    this.AdditionalComment = additionalComment
    this.ClientIPAddress = clientIPAddress
    this.FormSubmissionTimestamp = formSubmissionTimestamp
    this.SupportingFiles = supportingFiles
    this.Files = files
    this.ReferenceNumber = referenceNumber
    this.CIInfo = ciInfo
  }

  FirstName: string
  LastName: string
  Address: Address
  EmailAddress: string
  ReferralSource: string
  PhoneNumber: string
  PhoneNumberType: string
  IsSystemOwner: boolean
  LoanType: string
  Utility: Utility
  ServiceAddress: Address
  Meter: Meter
  AdditionalComment: string
  ClientIPAddress: string
  FormSubmissionTimestamp: string
  SupportingFiles: SupportingFile[]
  Files: File[]
  ReferenceNumber: string
  CIInfo?: CIInfo
}

export class Address {
  constructor(
    street: string,
    city: string,
    state: string,
    zipCode: string,
    country: string
  ) {
    this.Street = street
    this.City = city
    this.State = state
    this.ZipCode = zipCode
    this.Country = country
  }
  Street: string
  City: string
  State: string
  ZipCode: string
  Country: string
}

export class Meter {
  constructor(
    meterSerialNumber: string,
    nodeId: string,
    meterManufacturer: MeterManufacturer,
    meterModel: MeterModel,
    monitoringService?: string
  ) {
    this.MeterSerialNumber = meterSerialNumber
    this.NodeId = nodeId
    this.MeterManufacturer = meterManufacturer
    this.MeterModel = meterModel
    this.MonitoringService = monitoringService
  }

  MeterSerialNumber: string
  NodeId: string
  MeterManufacturer: MeterManufacturer
  MeterModel: MeterModel
  MonitoringService?: string
}

export enum MeterManufacturer {
  Other = 'Other',
}

export enum MeterModel {
  Other = 'Other',
}

export enum Utility {
  Other = 'Other',
}

export interface SupportingFile {
  // file: File
  fileName: string
  tagType: string
}

export const MeterMan = [
  { value: 'ABB' },
  { value: 'ABB (Power-One)' },
  { value: 'ABB/Elster' },
  { value: 'Accuenergy' },
  { value: 'Accuenergy (Canada) Inc.' },
  { value: 'AMETEK Power Instruments' },
  { value: 'Apparent Energy' },
  { value: 'Apsystems' },
  { value: 'Astropower' },
  { value: 'AU Optronics' },
  { value: 'BenQ Solar' },
  { value: 'Brand Electronic' },
  { value: 'Brultech Research' },
  { value: 'Canadian Solar' },
  { value: 'CARLO GAVAZZI' },
  { value: 'Chilicon Power' },
  { value: 'Continental Control Systems' },
  { value: 'Current Cost' },
  { value: 'Darfon Electronics' },
  { value: 'Davidge Controls' },
  { value: 'Delta Electronics' },
  { value: 'DENT Instruments' },
  { value: 'Diehl AKO Stiftung & Co. KG' },
  { value: 'Direct Grid Technologies' },
  { value: 'Draker Solar Design' },
  { value: 'Eaton' },
  { value: 'Eaton Corporation' },
  { value: 'eGauge Systems' },
  { value: 'EKM Metering' },
  { value: 'Electro Industries/Gaugetech' },
  { value: 'Elkor Technologies' },
  { value: 'Elster' },
  { value: 'E-MON' },
  { value: 'Enecsys' },
  { value: 'Energy Tracking' },
  { value: 'ENERNET' },
  { value: 'Enphase Energy' },
  { value: 'Exeltech' },
  { value: 'Fat Spaniel Technologies' },
  { value: 'Fronius International GmbH' },
  { value: 'Fronius USA' },
  { value: 'GE Energy' },
  { value: 'Generac Power Systems Inc.' },
  { value: 'General Electric' },
  { value: 'Global Power Products' },
  { value: 'Home Energy Systems' },
  { value: 'Huawei Technologies Co., Ltd.' },
  { value: 'ICP Solar Technologies' },
  { value: 'Integrated Metering Systems' },
  { value: 'ISAC' },
  { value: 'iSYS Systems' },
  { value: 'Itron' },
  { value: 'KACO' },
  { value: 'Kele' },
  { value: 'Landis+Gyr' },
  { value: 'Leviton Manufacturing' },
  { value: 'LG Electronics' },
  { value: 'Locus Energy' },
  { value: 'Lovato Electric' },
  { value: 'Measurlogic' },
  { value: 'MelRok' },
  { value: 'Metrum Technologies' },
  { value: 'Microtrend Technologies' },
  { value: 'MidNite Solar' },
  { value: 'natcon7' },
  { value: 'Northern Electric & Power Co.' },
  { value: 'OutBack Power Technologies' },
  { value: 'Pacific Solar' },
  { value: 'Petra Solar' },
  { value: 'Phoenix Contact' },
  { value: 'Poobah Industries' },
  { value: 'Power Measurement' },
  { value: 'Power Standards Lab' },
  { value: 'Powerhouse Dynamics' },
  { value: 'Power-One' },
  { value: 'PV Powered' },
  { value: 'Quadlogic' },
  { value: 'Real Goods Solar' },
  { value: 'REC Solar' },
  { value: 'Renesola' },
  { value: 'Righthand Engineering' },
  { value: 'SATEC INC' },
  { value: 'Schneider Electric' },
  { value: 'Schuco USA L.P.' },
  { value: 'Schweitzer Engineering Laboratories' },
  { value: 'Senva Sensors Inc' },
  { value: 'Siemens Industry Inc.' },
  { value: 'SMA America' },
  { value: 'SmartSynch' },
  { value: 'SOCOMEC' },
  { value: 'Solar Integrated Technologies' },
  { value: 'SolarBridge Technologies' },
  { value: 'SolarEdge' },
  { value: 'SolarEdge Technologies Ltd.' },
  { value: 'Solar-Log' },
  { value: 'SolarMagic/National Semiconductor' },
  { value: 'SolarQuest' },
  { value: 'SolarWorld' },
  { value: 'Solectria Renewables' },
  { value: 'Southwest Windpower' },
  { value: 'Sungrow Power Supply' },
  { value: 'SunPower' },
  { value: 'swebs / mysolarstats' },
  { value: 'TE Connectivity/Crompton Instruments' },
  { value: 'TED - The Energy Detective' },
  { value: 'Thompson Technology Industries' },
  { value: 'Tigo Energy' },
  { value: 'TransData' },
  { value: 'Veris Industries' },
  { value: 'Xantrex' },
]

export const MeterMod = [
  { value: 'CDD' },
  { value: 'PVI-3.0/3.6/3.8/4.2-TL-OUTD' },
  { value: 'PVI-5000/6000-TL-OUTD' },
  { value: 'PVS-166-TL-POWER-MODULE-1-US' },
  { value: 'PVS-166-TL-POWER-MODULE-2-US' },
  { value: 'PVS-175-TL-POWER-MODULE-1-US' },
  { value: 'PVS-175-TL-POWER-MODULE-2-US' },
  { value: 'PVS-60-TL-R-US' },
  { value: 'PVS-60-TL-SC-R-US' },
  { value: 'PVS-60-TL-SC-US' },
  { value: 'PVS-60-TL-S-R-US' },
  { value: 'PVS-60-TL-S-US' },
  { value: 'PVS-60-TL-US' },
  { value: 'TRIO-TM-60.0-TL-OUTD-US-480' },
  { value: 'TRIO-TM-60.0-TL-US-480' },
  { value: 'UNO-7.6/8.6-TL-OUTD' },
  { value: 'UNO-DM-3.3-TL-PLUS-US-SB-RA' },
  { value: 'UNO-DM-3.3-TL-PLUS-US-SE-RA' },
  { value: 'UNO-DM-3.3-TL-PLUS-US-SZM-RA' },
  { value: 'UNO-DM-3.3-TL-PLUS-US-SZ-RA' },
  { value: 'UNO-DM-3.8-TL-PLUS-US-SB-RA (240V)' },
  { value: 'UNO-DM-3.8-TL-PLUS-US-SE-RA (240V)' },
  { value: 'UNO-DM-3.8-TL-PLUS-US-SZM-RA (240V)' },
  { value: 'UNO-DM-3.8-TL-PLUS-US-SZ-RA (240V)' },
  { value: 'UNO-DM-4.6-TL-PLUS-US-SB-RA (240V)' },
  { value: 'UNO-DM-4.6-TL-PLUS-US-SE-RA (240V)' },
  { value: 'UNO-DM-4.6-TL-PLUS-US-SZM-RA (240V)' },
  { value: 'UNO-DM-4.6-TL-PLUS-US-SZ-RA (240V)' },
  { value: 'UNO-DM-5.0-TL-PLUS-US-SB-RA' },
  { value: 'UNO-DM-5.0-TL-PLUS-US-SE-RA' },
  { value: 'UNO-DM-5.0-TL-PLUS-US-SZM-RA' },
  { value: 'UNO-DM-5.0-TL-PLUS-US-SZ-RA' },
  { value: 'UNO-DM-5.0-TL-PLUS-US-SZ-RA-U' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SB-RA (208V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SB-RA (240V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SC-RA (208V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SC-RA (240V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SE-RA (208V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SE-RA (240V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-S-XRA (208V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-S-XRA (240V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SZM-RA (208V)' },
  { value: 'UNO-DM-6.0-TL-PLUS-US-SZM-RA (240V)' },
  { value: 'RGM-Module-US' },
  { value: 'AB1' },
  { value: 'ABS' },
  { value: 'AlphaPlus - A1D+' },
  { value: 'AlphaPlus - A1K+' },
  { value: 'AlphaPlus - A1R+' },
  { value: 'AlphaPlus - A1T+' },
  { value: 'AlphaPlus - A1TL+' },
  { value: 'Acuvim II' },
  { value: 'Acuvim IIE' },
  { value: 'Acuvim IIR' },
  { value: 'Acuvim IIW' },
  { value: 'Acuvim-AL' },
  { value: 'Acuvim-BL' },
  { value: 'Acuvim-CL' },
  { value: 'Acuvim-DL' },
  { value: 'Acuvim-EL' },
  { value: 'Acuvim-KL' },
  { value: 'AcuRev 1310' },
  { value: 'AcuRev 1312' },
  { value: 'AcuRev 1313' },
  { value: 'AcuRev 1314' },
  { value: 'Ci20' },
  { value: 'DPMS X1' },
  { value: 'DPMS XL' },
  { value: 'DPMS XL+' },
  { value: 'DPMS XPQ' },
  { value: 'DPMS-PM' },
  { value: 'JEMStar' },
  { value: 'MGI-ID (Insight Display)' },
  { value: 'ECU-3' },
  { value: 'APM2 SunChoice' },
  { value: 'AUO Data Logger' },
  { value: 'BenQ Data Logger' },
  { value: '20-1850' },
  { value: '20-1850CI' },
  { value: '20-CTR' },
  { value: '21-1850CI' },
  { value: '4-1850' },
  { value: 'ONE Meter' },
  { value: 'OneMeter' },
  { value: 'ECM-1240' },
  { value: 'GW-CE-RES-G20' },
  { value: 'EM24-DINAV53DIS' },
  { value: 'EM24-DINAV53DM1' },
  { value: 'EM24-DINAV53DM2' },
  { value: 'WM30-96' },
  { value: 'WM40-96' },
  { value: 'CP-100' },
  { value: 'RWNC-3D-240-MB' },
  { value: 'RWNC-3Y-208-MB' },
  { value: 'RWNC-3Y-480-MB' },
  { value: 'RWND-3D-240-MB' },
  { value: 'WattNode WNB-3D-240-P' },
  { value: 'WattNode WNB-3D-400-P' },
  { value: 'WattNode WNB-3D-480-P' },
  { value: 'WattNode WNB-3Y-208-P' },
  { value: 'WattNode WNB-3Y-400-P' },
  { value: 'WattNode WNB-3Y-480-P' },
  { value: 'WattNode WNB-3Y-600-P' },
  { value: 'WattNode WNC-3D-240-FT10' },
  { value: 'WattNode WNC-3D-240-MB' },
  { value: 'WattNode WNC-3D-400-FT10' },
  { value: 'WattNode WNC-3D-400-MB' },
  { value: 'WattNode WNC-3D-480-FT10' },
  { value: 'WattNode WNC-3D-480-MB' },
  { value: 'WattNode WNC-3Y-208-FT10' },
  { value: 'WattNode WNC-3Y-208-MB' },
  { value: 'WattNode WNC-3Y-400-FT10' },
  { value: 'WattNode WNC-3Y-400-MB' },
  { value: 'WattNode WNC-3Y-480-FT10' },
  { value: 'WattNode WNC-3Y-480-MB' },
  { value: 'WattNode WNC-3Y-600-FT10' },
  { value: 'WattNode WNC-3Y-600-MB' },
  { value: 'WND-WR-MB' },
  { value: 'Envi CC128' },
  { value: 'DDL100' },
  { value: 'EZ Meter A3131/3' },
  { value: 'EZ Meter A3133/3' },
  { value: 'EZ Meter A4231/3' },
  { value: 'EZ Meter A4233/3' },
  { value: 'DSS3366-TD' },
  { value: 'DSS3366-TD-A' },
  { value: 'SOLIVIA 3.0 NA G4 TL' },
  { value: 'SOLIVIA 3.8 NA G4 TL' },
  { value: 'SOLIVIA 5.2 NA G4 TL' },
  { value: 'SOLIVIA 6.6 NA G4 TL' },
  { value: 'SOLIVIA 7.6 NA G4 TL' },
  { value: 'PS24' },
  { value: 'PS3037' },
  { value: 'PLATINUM Webmaster' },
  { value: 'AN_Ethernet' },
  { value: 'PVDAQ Basic' },
  { value: 'PVDAQ Commercial' },
  { value: 'IQ150' },
  { value: 'IQ250' },
  { value: 'IQ260' },
  { value: 'IQ35M' },
  { value: 'PXM2250' },
  { value: 'PXM2260' },
  { value: 'PXM2270' },
  { value: 'PXM1100' },
  { value: 'PXM1200' },
  { value: 'PXM1300' },
  { value: 'EG4115' },
  { value: 'EG4130' },
  { value: 'eG3000' },
  { value: 'EG3010' },
  { value: 'eGauge2' },
  { value: 'Omnimeter Pulse UL v.4' },
  { value: 'Omnimeter Pulse v.4' },
  { value: 'Nexus 1250' },
  { value: 'Nexus 1252' },
  { value: 'Nexus 1500' },
  { value: 'Shark 100' },
  { value: 'Shark 100 S' },
  { value: 'Shark 200' },
  { value: 'WattsOn 1100-5A' },
  { value: 'WattsOn 1100-MCTA' },
  { value: 'WattsOn 1100-MCTB' },
  { value: 'WattsOn 1200-5A' },
  { value: 'WattsOn 1200-MCTA' },
  { value: 'WattsOn 1200-MCTB' },
  { value: 'WattsOn-1100-mA' },
  { value: 'WattsOn-1200-mA' },
  { value: 'WattsOn-Mark II' },
  { value: 'A3 Alpha - A3D' },
  { value: 'A3 Alpha - A3K' },
  { value: 'A3 Alpha - A3R' },
  { value: 'A3 Alpha - A3T' },
  { value: 'REX R1S' },
  { value: 'REX R1SD' },
  { value: 'D-MON 208100 KIT' },
  { value: 'D-MON 208100C KIT' },
  { value: 'D-MON 208100D KIT' },
  { value: 'D-MON 2081600 KIT' },
  { value: 'D-MON 2081600C KIT' },
  { value: 'D-MON 2081600D KIT' },
  { value: 'D-MON 208200 KIT' },
  { value: 'D-MON 208200C KIT' },
  { value: 'D-MON 208200D KIT' },
  { value: 'D-MON 20825 KIT' },
  { value: 'D-MON 20825C KIT' },
  { value: 'D-MON 20825D KIT' },
  { value: 'D-MON 2083200 KIT' },
  { value: 'D-MON 2083200C KIT' },
  { value: 'D-MON 2083200D KIT' },
  { value: 'D-MON 208400 KIT' },
  { value: 'D-MON 208400C KIT' },
  { value: 'D-MON 208400D KIT' },
  { value: 'D-MON 20850 KIT' },
  { value: 'D-MON 20850C KIT' },
  { value: 'D-MON 20850D KIT' },
  { value: 'D-MON 208800 KIT' },
  { value: 'D-MON 208800C KIT' },
  { value: 'D-MON 208800D KIT' },
  { value: 'D-MON 480100 KIT' },
  { value: 'D-MON 480100C KIT' },
  { value: 'D-MON 480100D KIT' },
  { value: 'D-MON 4801600 KIT' },
  { value: 'D-MON 4801600C KIT' },
  { value: 'D-MON 480200 KIT' },
  { value: 'D-MON 480200C KIT' },
  { value: 'D-MON 480200D KIT' },
  { value: 'D-MON 48025 KIT' },
  { value: 'D-MON 48025C KIT' },
  { value: 'D-MON 48025D KIT' },
  { value: 'D-MON 4803200 KIT' },
  { value: 'D-MON 4803200C KIT' },
  { value: 'D-MON 4803200D KIT' },
  { value: 'D-MON 480400 KIT' },
  { value: 'D-MON 480400C KIT' },
  { value: 'D-MON 480400D KIT' },
  { value: 'D-MON 48050 KIT' },
  { value: 'D-MON 48050C KIT' },
  { value: 'D-MON 48050D KIT' },
  { value: 'D-MON 480800 KIT' },
  { value: 'D-MON 480800C KIT' },
  { value: 'D-MON 480800D KIT' },
  { value: 'E-CON 2120100-SA KIT' },
  { value: 'E-CON 2120200-SA KIT' },
  { value: 'E-CON 212025-SA KIT' },
  { value: 'E-CON 212050-SA KIT' },
  { value: 'E-CON 2277100-SA KIT' },
  { value: 'E-CON 22772000-SA KIT' },
  { value: 'E-CON 227725-SA KIT' },
  { value: 'E-CON 227750-SA KIT' },
  { value: 'E-CON 3208100-SA KIT' },
  { value: 'E-CON 3208200-SA KIT' },
  { value: 'E-CON 320825-SA KIT' },
  { value: 'E-CON 320850-SA KIT' },
  { value: 'CG-A-US' },
  { value: 'GW-EU-RES-G20' },
  { value: 'WEMM' },
  { value: 'WEM-MX-120-D' },
  { value: 'WEM-MX-120-DBL' },
  { value: 'WEM-MX-120-ND' },
  { value: 'WEM-MX-240-D' },
  { value: 'WEM-MX-240-DBL' },
  { value: 'WEM-MX-240-ND' },
  { value: 'WEM-MX-480-D' },
  { value: 'WEM-MX-480-DBL' },
  { value: 'WEM-MX-480-ND' },
  { value: 'WEM-MX-ARV-DBL-EFC' },
  { value: 'WEM-MX-ARV-DBL-EFC-333' },
  { value: 'WEM-MX-ARV-DBL-EFC-5A' },
  { value: 'WEM-MX-ARV-DBL-EFC-LC' },
  { value: 'WEM-MX-ARV-DBL-EFC-LC-PO' },
  { value: 'WEM-MX-ARV-D-EFC' },
  { value: 'WEM-MX-ARV-D-EFC-333' },
  { value: 'WEM-MX-ARV-D-EFC-5A' },
  { value: 'WEM-MX-ARV-D-EFC-LC' },
  { value: 'WEM-MX-ARV-ND-EFC' },
  { value: 'WEM-MX-ARV-ND-EFC-333' },
  { value: 'WEM-MX-ARV-ND-EFC-5A' },
  { value: 'WEM-MX-ARV-ND-EFC-LC' },
  { value: 'K20' },
  { value: 'EMU' },
  { value: 'ENV-IQ-AM1-240' },
  { value: 'Envoy' },
  { value: 'ENV-S-AM1-120' },
  { value: 'HelioSentry HSA2-1-2-6W300' },
  { value: 'HelioSentry HSA2-1-2-6W400' },
  { value: 'SolarSentry Model SSA2-1-2-6W300' },
  { value: 'SolarSentry Model SSA2-1-2-6W400' },
  { value: 'PV2Web for Beacon M5 inverters' },
  { value: 'PV2Web for SATCON Inverters' },
  { value: 'PV2Web for SMA inverters' },
  { value: 'PV2Web Fronius Direct' },
  { value: 'Fronius Primo 10.0-1 208-240' },
  { value: 'Fronius Primo 11.4-1 208-240' },
  { value: 'Fronius Primo 12.5-1 208-240' },
  { value: 'Fronius Primo 15.0-1 208-240' },
  { value: 'Fronius Primo 3.8-1 208-240' },
  { value: 'Fronius Primo 5.0-1 208-240' },
  { value: 'Fronius Primo 6.0-1 208-240' },
  { value: 'Fronius Primo 7.6-1 208-240' },
  { value: 'Fronius Primo 8.2-1 208-240' },
  { value: 'Fronius Symo 10.0-3 208-240' },
  { value: 'Fronius Symo 10.0-3 480' },
  { value: 'Fronius Symo 12.0-3 208-240' },
  { value: 'Fronius Symo 12.5-3 480' },
  { value: 'Fronius Symo 15.0-3 208' },
  { value: 'Fronius Symo 15.0-3 480' },
  { value: 'Fronius Symo 17.5-3 480' },
  { value: 'Fronius Symo 20.0-3 480' },
  { value: 'Fronius Symo 22.7-3 480' },
  { value: 'Fronius Symo 24.0-3 480' },
  { value: 'Fronius Symo Advanced 10.0-3 208-240' },
  { value: 'Fronius Symo Advanced 10.0-3 480 Lite' },
  { value: 'Fronius Symo Advanced 12.0-3 208-240' },
  { value: 'Fronius Symo Advanced 12.0-3 480 Lite' },
  { value: 'Fronius Symo Advanced 15.0-3 480' },
  { value: 'Fronius Symo Advanced 15.0-3 480 Lite' },
  { value: 'Fronius Symo Advanced 20.0-3 480' },
  { value: 'Fronius Symo Advanced 20.0-3 480 Lite' },
  { value: 'Fronius Symo Advanced 22.7-3 480' },
  { value: 'Fronius Symo Advanced 22.7-3 480 Lite' },
  { value: 'Fronius Symo Advanced 24.0-3 480' },
  { value: 'Fronius Symo Advanced 24.0-3 480 Lite' },
  { value: 'Fronius Datalogger easy Box' },
  { value: 'Fronius Datalogger easy Card' },
  { value: 'Fronius Datalogger Interface Box' },
  { value: 'Fronius Datalogger pro Box' },
  { value: 'Fronius Datalogger pro Card' },
  { value: 'Fronius Datalogger Web' },
  { value: 'Fronius IG.access' },
  { value: 'FRONIUS IG.online' },
  { value: 'Fronius Interface Box' },
  { value: 'Fronius Interface Card easy' },
  { value: 'Fronius Personal Display' },
  { value: 'Fronius Solar Access' },
  { value: 'Fronius Solar Web' },
  { value: 'LCD Fronius Galvo Series' },
  { value: 'LCD Fronius IG Plus Series' },
  { value: 'LCD Fronius IG Series' },
  { value: 'B4001' },
  { value: 'B4002' },
  { value: 'I70S' },
  { value: 'KV' },
  { value: 'KV2' },
  { value: 'KV2c' },
  { value: 'KV2c+' },
  { value: 'W2' },
  { value: 'EPM2200' },
  { value: 'EPM6000' },
  { value: 'EPM9900' },
  { value: 'I-210+' },
  { value: 'I-210+C' },
  { value: 'ENER-COMM ECE-100' },
  { value: 'ENER-COMM ECE-200' },
  { value: 'ENER-COMM ECED-100' },
  { value: 'ENER-COMM ECED-200' },
  { value: '100 A' },
  { value: '25 A' },
  { value: '50 A' },
  { value: 'SUN2000-10KTL-USLO' },
  { value: 'SUN2000-11.4KTL-USLO' },
  { value: 'SUN2000-3.8KTL-USLO' },
  { value: 'SUN2000-5KTL-USLO' },
  { value: 'SUN2000-7.6KTL-USLO' },
  { value: 'SUN2000-9KTL-USLO' },
  { value: 'GreenMeter 61000' },
  { value: 'BL2081000-PKG-SO' },
  { value: 'BL208100-PKG-SO' },
  { value: 'BL2081200-PKG-SO' },
  { value: 'BL208200-PKG-SO' },
  { value: 'BL208400-PKG-SO' },
  { value: 'BL208600-PKG-SO' },
  { value: 'BL208800-PKG-SO' },
  { value: 'BL21201000-PKG-SO' },
  { value: 'BL2120100-PKG-SO' },
  { value: 'BL21201200-PKG-SO' },
  { value: 'BL2120200-PKG-SO' },
  { value: 'BL2120400-PKG-SO' },
  { value: 'BL2120600-PKG-SO' },
  { value: 'BL2120800-PKG-SO' },
  { value: 'BL22771000-PKG-SO' },
  { value: 'BL2277100-PKG-SO' },
  { value: 'BL22771200-PKG-SO' },
  { value: 'BL2277200-PKG-SO' },
  { value: 'BL2277400-PKG-SO' },
  { value: 'BL2277600-PKG-SO' },
  { value: 'BL2277800-PKG-SO' },
  { value: 'BL2401000-GL-PKG-SO' },
  { value: 'BL2401000-L-PKG-SO' },
  { value: 'BL240100-GL-PKG-SO' },
  { value: 'BL240100-L-PKG-SO' },
  { value: 'BL2401200-GL-PKG-SO' },
  { value: 'BL2401200-L-PKG-SO' },
  { value: 'BL240200-GL-PKG-SO' },
  { value: 'BL240200-L-PKG-SO' },
  { value: 'BL240400-GL-PKG-SO' },
  { value: 'BL240400-L-PKG-SO' },
  { value: 'BL240600-GL-PKG-SO' },
  { value: 'BL240600-L-PKG-SO' },
  { value: 'BL240800-GL-PKG-SO' },
  { value: 'BL240800-L-PKG-SO' },
  { value: 'BL32081000-PKG-SO' },
  { value: 'BL3208100-PKG-SO' },
  { value: 'BL32081200-PKG-SO' },
  { value: 'BL3208200-PKG-SO' },
  { value: 'BL3208400-PKG-SO' },
  { value: 'BL3208600-PKG-SO' },
  { value: 'BL3208800-PKG-SO' },
  { value: 'BL4801000-L-PKG-SO' },
  { value: 'BL4801000-PKG-SO' },
  { value: 'BL480100-L-PKG-SO' },
  { value: 'BL480100-PKG-SO' },
  { value: 'BL4801200-L-PKG-SO' },
  { value: 'BL4801200-PKG-SO' },
  { value: 'BL480200-L-PKG-SO' },
  { value: 'BL480200-PKG-SO' },
  { value: 'BL480400-L-PKG-SO' },
  { value: 'BL480400-PKG-SO' },
  { value: 'BL480600-L-PKG-SO' },
  { value: 'BL480600-PKG-SO' },
  { value: 'BL480800-L-PKG-SO' },
  { value: 'BL480800-PKG-SO' },
  { value: 'MMD1202001' },
  { value: 'MMD1202001-SCC' },
  { value: 'MMD1202001-T' },
  { value: 'MMD1202001-TSCC' },
  { value: 'MMS1202001' },
  { value: 'MMS1202001-SCC' },
  { value: 'MMS1202001-T' },
  { value: 'MMS1202001-TSCC' },
  { value: 'PCMNet' },
  { value: 'PVM-Net' },
  { value: 'Centron C1S' },
  { value: 'J4S' },
  { value: 'J5S' },
  { value: 'SENTINAL' },
  { value: 'KACO Display' },
  { value: 'KACO Pro Log L' },
  { value: 'KACO Pro Log M' },
  { value: 'KACO Pro Log XL' },
  { value: 'VISO' },
  { value: 'ENG-9000 (EnGenius)' },
  { value: 'AL Altimus 2S' },
  { value: 'AX Focus' },
  { value: 'Focus' },
  { value: 'MAXsys Elite' },
  { value: 'S4' },
  { value: 'S4e' },
  { value: '7B201-S02' },
  { value: 'LGENBOX-01' },
  { value: 'Lgate 100' },
  { value: 'Lgate 101E' },
  { value: 'LGate 120' },
  { value: 'LGate 320' },
  { value: 'LGate 50' },
  { value: 'DMG 800' },
  { value: 'DTS 305' },
  { value: 'DTS 307' },
  { value: 'DTS 310' },
  { value: 'DTS DC' },
  { value: 'DTS SKT' },
  { value: 'DTS SKTD' },
  { value: 'DTS SMX' },
  { value: 'ESP Touch Pro (EMG-1212)' },
  { value: 'ESP Touch Pro (EMG-2412)' },
  { value: 'Landis+Gyr Focus' },
  { value: 'SEA-1' },
  { value: 'Classic 150' },
  { value: 'Classic 200' },
  { value: 'Classic 250' },
  { value: 'PMRS' },
  { value: 'BDG-256' },
  { value: 'BDG-256P3' },
  { value: 'Mate' },
  { value: 'Mate 3' },
  { value: 'SBX5048-120/240' },
  { value: 'Sunlogger' },
  { value: 'S200-V120-Z00D1-300' },
  { value: 'EEM-MA200' },
  { value: 'EEM-MA250' },
  { value: 'EEM-MA400' },
  { value: 'EEM-MA600' },
  { value: 'SB-001' },
  { value: 'ION 6200' },
  { value: 'ION 7330' },
  { value: 'ION 7350' },
  { value: 'ION 7550' },
  { value: 'ION 7650' },
  { value: 'ION 8600' },
  { value: 'PQube 3' },
  { value: 'PQube 3e' },
  { value: 'eMonitor4' },
  { value: 'PVI-10.0-I-OUTD-S2-US-208-NG-Z' },
  { value: 'PVI-10.0-I-OUTD-S2-US-480-NG-Z' },
  { value: 'PVI-10.0-I-OUTD-S-US-208-NG-Z' },
  { value: 'PVI-10.0-I-OUTD-S-US-480-NG-Z' },
  { value: 'PVI-3.0-OUTD-S-US-Z' },
  { value: 'PVI-3.6-OUTD-S-US-Z' },
  { value: 'PVI-3.8-I-OUTD-S-US-NG-Z' },
  { value: 'PVI-4.2-OUTD-S-US-Z' },
  { value: 'PVI-4.6-I-OUTD-S-US-NG-Z' },
  { value: 'PVI-5000-OUTD-US-Z' },
  { value: 'PVI-6000-OUTD-US-Z' },
  { value: 'PVI-CENTRAL-100-US' },
  { value: 'PVI-CENTRAL-250-US' },
  { value: 'PVI-CENTRAL-300-US' },
  { value: 'PVI-CENTRAL-50-US' },
  { value: 'TRIO-20.0-TL-OUTD-US-480' },
  { value: 'TRIO-27.6-TL-OUTD-US-480' },
  { value: 'ULTRA-1100-TL-OUTD-1-US-690-x-y-z' },
  { value: 'ULTRA-1100-TL-OUTD-2-US-690-x-y-z' },
  { value: 'ULTRA-1100-TL-OUTD-3-US-690-x-y-z' },
  { value: 'ULTRA-1100-TL-OUTD-4-US-690-x-y-z' },
  { value: 'ULTRA-1500-TL-OUTD-1-US-690-x-y-z' },
  { value: 'ULTRA-1500-TL-OUTD-2-US-690-x-y-z' },
  { value: 'ULTRA-1500-TL-OUTD-3-US-690-x-y-z' },
  { value: 'ULTRA-1500-TL-OUTD-4-US-690-x-y-z' },
  { value: 'ULTRA-750-TL-OUTD-1-US-690-x-y-z' },
  { value: 'ULTRA-750-TL-OUTD-2-US-690-x-y-z' },
  { value: 'ULTRA-750-TL-OUTD-3-US-690-x-y-z' },
  { value: 'ULTRA-750-TL-OUTD-4-US-690-x-y-z' },
  { value: 'UNO-2.0-I-OUTD-US' },
  { value: 'UNO-2.5-I-OUTD-US' },
  { value: 'PVM1010' },
  { value: 'MC-5/MC-5c' },
  { value: 'RSM-5/RSM-5c' },
  { value: 'S-10' },
  { value: 'S-20' },
  { value: 'PVwatch' },
  { value: 'REC Solar Wireless Display' },
  { value: 'Replus MRG' },
  { value: 'Replus-250A' },
  { value: 'Replus-250B' },
  { value: 'WinVerter-Monitor' },
  { value: 'WinVerter-Monitor FX-MX' },
  { value: 'BFM II' },
  { value: 'BFM136' },
  { value: 'EM133' },
  { value: 'eXpertmeter EM920' },
  { value: 'PM130EH PLUS' },
  { value: 'PM130P PLUS' },
  { value: 'PM172E-N' },
  { value: 'E5600' },
  { value: 'EM35' },
  { value: 'Energy Meter' },
  { value: 'HDM 1-Meter and 4-Meter' },
  { value: 'HDM 8-Meter and 16-Meter' },
  { value: 'ION 8650' },
  { value: 'ION7400' },
  { value: 'PM 700 Power Meter' },
  { value: 'PM 800 Power Meter' },
  { value: 'PM5000' },
  { value: 'Series 3000 Circuit Monitor' },
  { value: 'Series 4000 Circuit Monitor' },
  { value: 'Sunny Beam' },
  { value: 'Sunny WebBox' },
  { value: 'SEL-735' },
  { value: 'EM-PULSE' },
  { value: 'EM-RS485' },
  { value: 'US2:SEM3CAB[5;10;20]FT' },
  { value: 'US2:SEM3CAB[6,12,24,36]INCH' },
  { value: 'US2:SEM3CONTROLLER' },
  { value: 'US2:SEM3PHAMETER' },
  { value: 'US2:SEM3PLAMETER' },
  { value: 'US2:SEM3RACK3;6;9;15;21' },
  { value: 'US2:SEM3TOUCHP7;9,12,15,19' },
  { value: 'RGM05KIT-US-10' },
  { value: 'SB3.0-1SP-US-40 (208V)' },
  { value: 'SB3.0-1SP-US-40 (240V)' },
  { value: 'SB3.0-1SP-US-41 [208V]' },
  { value: 'SB3.0-1SP-US-41 [240V]' },
  { value: 'SB3.0-1TP-US-40 (208V)' },
  { value: 'SB3.0-1TP-US-40 (240V)' },
  { value: 'SB3.8-1SP-US-40 (208V)' },
  { value: 'SB3.8-1SP-US-40 (240V)' },
  { value: 'SB3.8-1SP-US-41 [208V]' },
  { value: 'SB3.8-1SP-US-41 [240V]' },
  { value: 'SB3.8-1TP-US-40 (208V)' },
  { value: 'SB3.8-1TP-US-40 (240V)' },
  { value: 'SB5.0-1SP-US-40 (208V)' },
  { value: 'SB5.0-1SP-US-40 (240V)' },
  { value: 'SB5.0-1SP-US-41 [208V]' },
  { value: 'SB5.0-1SP-US-41 [240V]' },
  { value: 'SB5.0-1TP-US-40 (208V)' },
  { value: 'SB5.0-1TP-US-40 (240V)' },
  { value: 'SB6.0-1SP-US-40 (208V)' },
  { value: 'SB6.0-1SP-US-40 (240V)' },
  { value: 'SB6.0-1SP-US-41 [208V]' },
  { value: 'SB6.0-1SP-US-41 [240V]' },
  { value: 'SB6.0-1TP-US-40 (208V)' },
  { value: 'SB6.0-1TP-US-40 (240V)' },
  { value: 'SB7.0-1SP-US-40 (208V)' },
  { value: 'SB7.0-1SP-US-40 (240V)' },
  { value: 'SB7.0-1SP-US-41 [208V]' },
  { value: 'SB7.0-1SP-US-41 [240V]' },
  { value: 'SB7.0-1TP-US-40 (208V)' },
  { value: 'SB7.0-1TP-US-40 (240V)' },
  { value: 'SB7.7-1SP-US-40 (208V)' },
  { value: 'SB7.7-1SP-US-40 (240V)' },
  { value: 'SB7.7-1SP-US-41 [208V]' },
  { value: 'SB7.7-1SP-US-41 [240V]' },
  { value: 'SB7.7-1TP-US-40 (208V)' },
  { value: 'SB7.7-1TP-US-40 (240V)' },
  { value: 'SBS3.8-US-10' },
  { value: 'SBS5.0-US-10' },
  { value: 'SBS6.0-US-10' },
  { value: 'SC-Meter' },
  { value: 'STP 12000TL-US-10' },
  { value: 'STP 15000TL-US-10' },
  { value: 'STP 20000TL-US-10' },
  { value: 'STP 24000TL-US-10' },
  { value: 'STP 30000TL-US-10' },
  { value: 'Sunny Boy Control' },
  { value: 'Sunny Boy Control Light' },
  { value: 'Sunny Boy Control Plus' },
  { value: 'Sunny Boy Control Plus-485' },
  { value: 'Sunny Boy Control-485' },
  { value: 'Sunny Data' },
  { value: 'Sunny Data Control' },
  { value: 'Sunny Multigate (MULTIGATE-US-10)' },
  { value: 'SWR LCD' },
  { value: 'Itron CENTRON GPRS SmartMeter' },
  { value: '48290101 / DIRIS Digiware C-31' },
  { value: '48290102 / DIRIS Digiware U-30' },
  { value: '48290103 / DIRIS Digiware C-32' },
  { value: '48290105 / DIRIS Digiware U-10' },
  { value: '48290106 / DIRIS Digiware U-20' },
  { value: '48290110 / DIRIS Digiware I-30' },
  { value: '48290111 / DIRIS Digiware I-31' },
  { value: '48290112 / DIRIS Digiware I-60' },
  { value: '48290113 / DIRIS Digiware I-61' },
  { value: '48290128 / DIRIS Digiware I-33' },
  { value: '48290129 / DIRIS Digiware I-43' },
  { value: '48290130 / DIRIS Digiware I-35' },
  { value: '48290131 / DIRIS Digiware I-45' },
  { value: 'DIRIS A10' },
  { value: 'DIRIS A20' },
  { value: 'DIRIS A40' },
  { value: 'DIRIS B-10' },
  { value: 'DIRIS B-30' },
  { value: 'REM-ESA-ASSURE' },
  { value: 'REM-PBI-ASSURE' },
  { value: 'REM-UTILITY-ASSURE' },
  { value: 'Power Manager' },
  { value: 'SE10000A-US' },
  { value: 'SE10kUS' },
  { value: 'SE11400A-US' },
  { value: 'SE20kUS' },
  { value: 'SE3000A-US' },
  { value: 'SE3000H-US' },
  { value: 'SE3800A-US' },
  { value: 'SE3800H-US' },
  { value: 'SE5000A-US' },
  { value: 'SE5000H-US' },
  { value: 'SE6000A-US' },
  { value: 'SE6000H-US' },
  { value: 'SE7000A-US' },
  { value: 'SE7600A-US' },
  { value: 'SE7600H-US' },
  { value: 'SE9kUS' },
  { value: 'SE-RGMTR-1D-240C-A' },
  { value: 'SE-RGMTR-3D-208V-A' },
  { value: 'SE-RGMTR-3Y-208V-A' },
  { value: 'SE-RGMTR-3Y-480V-A' },
  { value: 'Solar-Log 500/1000 RGM' },
  { value: 'RECtrack 1' },
  { value: 'RECtrack 2' },
  { value: 'RECtrack 3' },
  { value: 'rMeter' },
  { value: 'STL 200' },
  { value: 'STL 400' },
  { value: 'STL 800' },
  { value: 'LCD PVI 13/15kW' },
  { value: 'LCD PVI 1800-2500' },
  { value: 'LCD PVI 3000-5300' },
  { value: 'LCD PVI 60/82/95kW' },
  { value: 'SolrenView 1PH REV' },
  { value: 'SolrenView 1PH REV-panel' },
  { value: 'SolrenView 3PH 200A REV' },
  { value: 'SolrenView 3PH 400A REV' },
  { value: 'SolrenView 3PH 800A REV' },
  { value: 'SolrenView Inverter Direct' },
  { value: 'Skystream 3.7' },
  { value: 'SG125HV (600V)' },
  { value: 'ACPV Supervisor' },
  { value: 'PVS5X' },
  { value: 'SMS SPRf Series' },
  { value: 'SMS SPRm Series' },
  { value: 'SMS SPRx Series' },
  { value: 'HEM' },
  { value: 'Integra 1530' },
  { value: 'Integra 1540' },
  { value: 'Integra 1560' },
  { value: 'Integra 1580' },
  { value: 'TED 5000' },
  { value: 'TED Pro Series' },
  { value: 'SunPac' },
  { value: 'MM-EP and KACO Inverters' },
  { value: 'MM-EP and SMA inverters' },
  { value: 'MM-ES and KACO Inverters' },
  { value: 'MM-ES and SMA inverters' },
  { value: 'MARK-V EMS60' },
  { value: 'E50' },
  { value: 'E51C2' },
  { value: 'E51C3' },
  { value: 'H8030-0100-2' },
  { value: 'H8030-0300-2' },
  { value: 'H8031-0100-2' },
  { value: 'H8031-0300-2' },
  { value: 'H8035-0800-4' },
  { value: 'H8035-100-2' },
  { value: 'H8035-1600-4' },
  { value: 'H8035-2400-4' },
  { value: 'H8035-300-2' },
  { value: 'H8035-400-3' },
  { value: 'H8036-0800-4' },
  { value: 'H8036-100-2' },
  { value: 'H8036-1600-4' },
  { value: 'H8036-2400-4' },
  { value: 'H8036-300-2' },
  { value: 'H8036-400-3' },
  { value: 'H8043-0100-2' },
  { value: 'H8043-0100-2(100A)' },
  { value: 'H8043-0300-2' },
  { value: 'H8043-0300-2(300A)' },
  { value: 'H8043-0800-3' },
  { value: 'H8043-0800-4' },
  { value: 'H8043-400-3' },
  { value: 'H8044-0100-2(100A)' },
  { value: 'H8044-0300-2(300A)' },
  { value: 'H8051-100-2' },
  { value: 'H8051-300-2' },
  { value: 'H8163-0100-0-1' },
  { value: 'H8163-0100-0-2' },
  { value: 'H8163-0100-0-3' },
  { value: 'H8163-01600-4-3' },
  { value: 'H8163-0200-1-1' },
  { value: 'H8163-0200-1-2' },
  { value: 'H8163-0200-1-3' },
  { value: 'H8163-0300-2-1' },
  { value: 'H8163-0300-2-2' },
  { value: 'H8163-0300-2-3' },
  { value: 'H8163-0400-3-2' },
  { value: 'H8163-0400-3-3' },
  { value: 'H8163-0800-3-2' },
  { value: 'H8163-0800-3-3' },
  { value: 'H8163-0800-4-3' },
  { value: 'H8163-2400-4-3' },
  { value: 'STRM - Remote Meter' },
  { value: 'XW MPPT60' },
  { value: 'XW SCP' },
]
